if (!customElements.get('dual-block-slider')) {
  customElements.define('dual-block-slider', class DualBlockSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        gridWrap: '.dual-block-grid',
        items: '.dual-block-item'
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper'
      };

      this.wrapper = this.querySelector(this.selectors.gridWrap);
      this.items = this.querySelector(this.selectors.items);
      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.addEventListener('change', this.init.bind(this));
      this.init();
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;

      this.sliderOptions = {
        init: false,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        speed: 500,
        loop: true,
        threshold: 2
      };

      this.wrapper.classList.add(this.classes.swiper);
      this.wrapper.classList.remove(this.classes.grid);

      this.sliderInstance = new window.FoxTheme.Carousel(this.wrapper, this.sliderOptions);
      this.sliderInstance.init();
    }

    destroySlider() {
      this.wrapper.classList.remove(this.classes.swiper);
      this.wrapper.classList.add(this.classes.grid);

      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  });
}